export const GET_CMS_CERTIFICACIONES = "GET_CMS_CERTIFICACIONES";
export const GET_CMS_CERTIFICACIONES_ERROR = "GET_CMS_CERTIFICACIONES_ERROR";